import axios from "axios";
import Swal from "sweetalert2";

const PAGINAS_DE_INGRESO = ["/", "/login", "/Login"];

const esDeLaIntranet = (url = "") => {
  const base = axios.defaults.baseURL;
  return !/^https?:\/\//i.test(url) || (Boolean(base) && url.startsWith(base));
};

/**
 * Un 401 de la intranet fuera del login es una sesión vencida: avisa una sola vez y vuelve al inicio.
 * La petición que recibe el 401 queda sin resolver a propósito: la página se recarga al aceptar el aviso
 * y así ninguna pantalla muestra encima su propio error de "No autenticado".
 */
export function instalarAvisoDeSesionVencida() {
  let avisando = false;

  const avisar = () => {
    if (avisando) return;
    avisando = true;
    Swal.fire({
      icon: "warning",
      title: "Tu sesión venció",
      text: "Por seguridad cerramos tu sesión. Ingresá nuevamente para continuar.",
      confirmButtonText: "Ingresar",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => window.location.assign("/"));
  };

  return axios.interceptors.response.use(
    (respuesta) => respuesta,
    (error) => {
      const vencida =
        error?.response?.status === 401 &&
        esDeLaIntranet(error.config?.url) &&
        !PAGINAS_DE_INGRESO.includes(window.location.pathname);
      if (!vencida) return Promise.reject(error);

      avisar();
      return new Promise(() => {});
    },
  );
}
